import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PageNotFound from "./pages/PageNotFound";
import Auth from "./pages/Auth";
import Myaccount from "./pages/Myaccount";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Free from "./pages/Free";
import Contact from "./pages/Contact";
import MyPTE from "./pages/MyPTE";

const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/free" element={<Free />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/myPTE" element={<MyPTE />} />
        <Route path="/terms&conditions" element={<Terms />} />
        <Route path="/privacypolicy" element={<Privacy />} />
        <Route path="/auth/myaccount" element={<Myaccount />} />
        <Route path="/*" element={<PageNotFound />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
